import { useState } from '@wordpress/element';
import './style.scss';
import { __ } from '@wordpress/i18n';
const AIContent = ({ handleChangeSectionField, index, editorRef }) => {
    const [showAIPopup, setShowAIPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    const closeAIPopup = () => setShowAIPopup(false);

    const handleGenerateText = async () => {
        const prompt = document.getElementById('userInput')?.value;        
        if (!prompt || prompt.trim() === '') {
            alert(__('Please Right your prompt!', 'cv-builder'));
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(bwdcv_scgp_openai_api_vars.api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    action: 'bwdcv_scgp_openai_api_request',
                    prompt: prompt
                })
            });
            const data = await response.json();

            if (data.error) {
                alert(__('Error: ' + data.error, 'cv-builder'));
            } else {
                const aiGeneratedText = data.response || __('No response from API', 'cv-builder');                
                typeEffect(aiGeneratedText);                
                setTimeout(() => {
                    handleChangeSectionField(aiGeneratedText, index, "description");
                    if (editorRef?.current) {
                        editorRef.current.value = aiGeneratedText;
                    }
                    closeAIPopup();
                }, aiGeneratedText.length * 20 + 100); 
            }
        } catch (error) {
            alert(__('Error generating content. Please try again.', 'cv-builder'));
        }
        setLoading(false);
    };
    return (
        <div className='bwdcv-ai-content-gen'>
            <div className='bwdcv-ai-popup' onClick={() => bwdcv_data?.licenseStatus === 'activate' ? setShowAIPopup(true) : ''}>
                * ˚ ✦ {__('AI About', 'cv-builder')} * ˚ ✦
            </div>
            {showAIPopup && (
                <div className='bwdcv-ai-input-overlay' onClick={closeAIPopup}>
                    <div className='bwdcv-ai-input-wrap' onClick={(e) => e.stopPropagation()}>
                        <span className="bwdcv-ai-close-btn" onClick={closeAIPopup}>×</span>
                        <textarea id="userInput" placeholder={__('Type your prompt here...', 'cv-builder')} />
                        <button 
                            className='bwdcv-ai-generate' 
                            onClick={handleGenerateText} 
                            disabled={loading}
                        >
                            {loading ? __('⏳ Generating...', 'cv-builder') : __('✦ Generate ✦', 'cv-builder')}
                        </button>
                    </div>
                </div>
            )}
            <div
                id="contentGeResult"
                style={{
                    display: 'none',
                }}
            ></div>
        </div>
    );
};

export default AIContent;

function typeEffect(text) {
    let index = 0;
    const resultDiv = document.getElementById('contentGeResult');
    if (!resultDiv) return;
    
    resultDiv.innerHTML = "";

    function typeNext() {
        if (index < text.length) {
            resultDiv.innerHTML += text.charAt(index);
            index++;
            setTimeout(typeNext, 20);
        }
    }

    typeNext();
}